<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
}
#app {
  height: 100vh;
  width: 100%;
}
.el-sub-menu__title:hover {
  background-color: #425c8f !important;
}
.b_line {
  width: calc(100% + 40px);
  height: 1px;
  background: #edeffd;
  margin-left: -20px;
}

.el-select-dropdown__wrap {
  border: 1px pink solid;
  background: #ffffff;
  border: none;
  box-shadow: 0px 0px 30px 0px rgb(118 133 164 / 15%);
  border-radius: 4px;
}
.selected {
  background-color: var(--el-fill-color-light);
}

:deep(.el-input__inner) {
  &::placeholder {
    font-size: 12px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    color: #a1a4af;
    line-height: 34px;
  }
}
.tablebox {
  padding: 18px;
  box-sizing: border-box;
}
</style>

<style lang="less">
.el-dialog {
  border-radius: 16px 16px 14px 14px !important;
  .el-dialog__header {
    width: 100%;
    line-height: 36px;
    font-size: 12px;
    height: 36px;
    background: linear-gradient(0deg, #0981ff 0%, #0981ff 100%);
    border-radius: 14px 14px 0px 0px;
    padding: 0;
    margin: 0;
    overflow: hidden;
  }

  .el-dialog__title {
    line-height: 36px;
    font-size: 14px;
    color: #ffffff;
    margin-left: 24px;
  }
  .el-dialog__body {
    padding-bottom: 0;
    padding-top: 12px;
  }
  .el-dialog__headerbtn {
    top: -6px !important;
  }
  .el-dialog__close {
    color: #ffffff !important;
    font-size: 20px !important;
  }
}
.button2 {
  button {
    border: none !important;
  }
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #78b4b4;
}
input:focus {
  outline: none; // 如何把蓝色去掉？
  border: none; // 如何改成别的颜色？
  // box-shadow: 0 0 0 1px #0981ff inset !important;
}
:deep(.el-input__wrapper) {
  border-radius: 16px;
  width: 180px;
}
.el-input__inner:hover {
  // box-shadow: 0 0 0 1px #0981ff inset !important;
  // cursor: pointer;
}
.el-overlay-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.is-focus) {
  box-shadow: none !important;
}
.mytooltip {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; //控制行数
  overflow: hidden;
}
.el-dialog {
  margin: 0 !important;
}
// :deep(.el-input__wrapper:hover) {
//   box-shadow: 0 0 0 1px #0981ff inset !important;
// }
</style>
